module.exports = __webpack_public_path__ + "static/25-5eb5d1bac6a6671eecd12d5e1ae9ea75.png";